import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ProjectSetup from "./routes/ProjectSetup";
import RoleSetup from "./routes/RoleSetup";
import ServiceActivityReflectionQuestions from "./routes/ServiceActivityReflectionQuestions";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import { getRelativePath } from "Utils";

export default store => ({
  path: "projects-settings-v2",
  component: withAsyncRouteLoading(() =>
    Promise.all([import("./components")])
      .then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
      .catch(err => {
        return err;
      })
  ),
  onEnter(nextState, replace) {
    if (_.last(nextState.routes).path == "projects-settings-v2") {
      const route = getNextMenuRoute("PROJECT_SETTING_V2");
      if (route) {
        replace(getRelativePath(route));
      } else {
        replace(getRelativePath("../"));
      }
    }
  },
  childRoutes: [
    ProjectSetup(store),
    RoleSetup(store),
    ServiceActivityReflectionQuestions(store),
  ],
});
